
const Skeleton = ({ className }: { className?: string }) => {
  return (
    <div className={`bg-gray-200  dark:bg-darkborder  animate-pulse w-full  rounded ${className}`}></div>
  );
};

export default Skeleton;
